var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsersThree = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333132",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14.184 19.688a4.375 4.375 0 1 0 0-8.75 4.375 4.375 0 0 0 0 8.75M21.621 12.688a6.54 6.54 0 0 1 5.25 2.624M1.496 15.313a6.54 6.54 0 0 1 5.25-2.626"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333132",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M7.883 23.625a7.01 7.01 0 0 1 12.6 0M6.746 12.688A3.5 3.5 0 1 1 10.18 8.53M18.188 8.531a3.5 3.5 0 1 1 3.434 4.156"
})));
export default SvgUsersThree;